import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// MeR 260422 every component inside your app can access the shared state via useApp()
import { AppProvider } from './context/AppContext';

const root = createRoot(document.getElementById('root'));
root.render(
  <AppProvider>
    <App />
  </AppProvider>
);
